/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState, useContext, useCallback, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import { Acl } from 'modules/common/components/Acl';
import NotificationBadge, { Effect } from 'react-notification-badge';
import ToggleFetcherTimer from 'modules/common/components/ToggleFetcherTimer';
import { getJson } from 'session';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';

import Applications from './Applications';
import ViewTransmittalModal from '../modals/ViewTransmittalModal';
import ReprintTransmittalModal from '../modals/ReprintTransmittalModal';
import TransmittalListModal from '../modals/TransmittalListModal';
import * as actions from '../actions';
import * as c from '../constant';

function ApplicationContainer({
  match,
  pathName,
  permissions,
  generateTransmittal,
  transactionListCount,
  getTransactionCount,
  getList,
  list,
}) {
  const setModal = useContext(ModalContext);
  const onSelectCallbackTimer = useSelector(({ api }) =>
    _.get(api, `${c.CALLBACK_TIMER}.item` || {})
  );
  // TODO: create custom hooks for notification badge later
  const newApplicationCounts = _.get(transactionListCount, 'new_applications');

  const updateListCountData = useCallback(() => {
    getTransactionCount();
  }, [transactionListCount]);

  const checkTransmittalCount =
    list.filter(item => {
      return (
        ['BPLS'].indexOf(_.get(item, 'attributes.module_type')) > -1 &&
        ['NEW', 'RENEWAL', 'DELINQUENT', 'CHANGE', 'RETIREMENT'].indexOf(
          _.get(item, 'attributes.transaction_type')
        ) > -1 &&
        ['FOR LICENSE ASSESSMENT', 'FOR PERMIT PROCESS'].indexOf(
          _.get(item, 'included.bplsApplication.attributes.status')
        ) > -1 &&
        (_.isNull(
          _.get(item, 'included.bplsApplication.attributes.transmittal_no')
        ) ||
          _.isEmpty(
            _.get(item, 'included.bplsApplication.attributes.transmittal_no')
          ))
      );
    })?.length || 0;

  useEffect(() => {
    updateListCountData();
  }, [checkTransmittalCount]);

  const getType = () => {
    if (`${pathName.indexOf('bpls/applications/renewal')}` > -1) {
      return 'RENEWAL';
    }
    // if (`${pathName.indexOf('bpls/applications/new')}` > -1) {
    //   return 'NEW';
    // }
    if (`${pathName.indexOf('bpls/applications/retirement')}` > -1) {
      return 'RETIREMENT';
    }
    if (`${pathName.indexOf('bpls/applications/change')}` > -1) {
      return 'CHANGE';
    }
    if (`${pathName.indexOf('bpls/applications/quarterly')}` > -1) {
      return 'QUARTERLY';
    }
    if (`${pathName.indexOf('bpls/applications/delinquent')}` > -1) {
      return 'DELINQUENT';
    }
    return 'NEW';
  };

  const onGenerateTransmittal = e => {
    e.preventDefault();

    const args = {
      transaction_type: getType(),
    };

    generateTransmittal(args, res => {
      setModal({
        isOpen: true,
        content: (
          <ViewTransmittalModal
            transmittalNumber={_.get(res, 'res.data.attributes.transmittal_no')}
          />
        ),
        title: 'Generate Transmittal',
        modalSize: 'modal-xl',
      });
    });

    setTimeout(() => {
      const params = {
        transaction_type: getType(),
        module_type: 'BPLS',
      };

      getList(params);
    }, 2000);
  };

  const reprintTransmittal = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ReprintTransmittalModal type="NEW" />,
      title: 'Reprint Transmittal',
      modalSize: 'modal-sm',
    });
  };

  const handleTransmittalList = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <TransmittalListModal type={getType()} />,
      title: 'Transmittal List',
      modalSize: 'modal-lg',
    });
  };

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['E2E BPLS NEW TRANSACTION']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/bpls/applications/new"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/applications/new') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    <div
                      className="position-absolute fixed-top fixed-right"
                      style={{ zIndex: '1' }}
                    >
                      <NotificationBadge
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{ height: '25px', width: '25px', top: '2px', right: '7px', }}
                        count={_.get(newApplicationCounts, 'NEW', 0)}
                        effect={Effect.SCALE}
                      />
                    </div>
                    New
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E BPLS RENEWAL TRANSACTION']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/bpls/applications/renewal"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/applications/renewal') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    <div
                      className="position-absolute fixed-top fixed-right"
                      style={{ zIndex: '1' }}
                    >
                      <NotificationBadge
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{ height: '25px', width: '25px', top: '2px', right: '7px', }}
                        count={_.get(newApplicationCounts, 'RENEWAL', 0)}
                        effect={Effect.SCALE}
                      />
                    </div>
                    Renewal
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E BPLS QUARTERLY TRANSACTION']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/bpls/applications/quarterly"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/applications/quarterly') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    <div
                      className="position-absolute fixed-top fixed-right"
                      style={{ zIndex: '1' }}
                    >
                      <NotificationBadge
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{ height: '25px', width: '25px', top: '2px', right: '7px', }}
                        count={_.get(newApplicationCounts, 'QUARTERLY', 0)}
                        effect={Effect.SCALE}
                      />
                    </div>
                    Quarterly
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E BPLS DELINQUENT TRANSACTION']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/bpls/applications/delinquent"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/applications/delinquent') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    <div
                      className="position-absolute fixed-top fixed-right"
                      style={{ zIndex: '1' }}
                    >
                      <NotificationBadge
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{ height: '25px', width: '25px', top: '2px', right: '7px', }}
                        count={_.get(newApplicationCounts, 'DELINQUENT', 0)}
                        effect={Effect.SCALE}
                      />
                    </div>
                    Delinquent
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E BPLS CHANGE REQUEST TRANSACTION']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/bpls/applications/change"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/applications/change') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    <div
                      className="position-absolute fixed-top fixed-right"
                      style={{ zIndex: '1' }}
                    >
                      <NotificationBadge
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{ height: '25px', width: '25px', top: '2px', right: '7px', }}
                        count={_.get(newApplicationCounts, 'CHANGE', 0)}
                        effect={Effect.SCALE}
                      />
                    </div>
                    Change Request
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E BPLS RETIREMENT TRANSACTION']) && (
                <li className="nav-item position-relative">
                  <Link
                    to="/bpls/applications/retirement"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('bpls/applications/retirement') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    <div
                      className="position-absolute fixed-top fixed-right"
                      style={{ zIndex: '1' }}
                    >
                      <NotificationBadge
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{ height: '25px', width: '25px', top: '2px', right: '7px', }}
                        count={_.get(newApplicationCounts, 'RETIREMENT', 0)}
                        effect={Effect.SCALE}
                      />
                    </div>
                    Retirement
                  </Link>
                </li>
              )}
            </ul>
            {Acl(permissions, ['VIEW TRANSMITTAL']) && (
              <div className="ml-2 my-auto">
                <ToggleFetcherTimer callback={onSelectCallbackTimer} />
              </div>
            )}
            {getType() !== 'QUARTERLY' && (
              <div className="d-flex ml-auto mr-3 my-2">
                {Acl(permissions, ['E2E BPLS PRINT TRANSMITTAL']) && (
                  <button
                    type="submit"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2   "
                    onClick={onGenerateTransmittal}
                  >
                    PRINT TRANSMITTAL &nbsp;
                    <i className="fas fa-print" />
                  </button>
                )}
                {Acl(permissions, ['E2E BPLS REVIEW TRANSMITTAL']) && (
                  <button
                    type="submit"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
                    onClick={reprintTransmittal}
                  >
                    REPRINT TRANSMITTAL &nbsp;
                    <i className="fas fa-print" />
                  </button>
                )}
                {Acl(permissions, ['E2E BPLS TRANSMITTAL LIST']) && (
                  <button
                    type="submit"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold ml-2"
                    onClick={handleTransmittalList}
                  >
                    VIEW TRANSMITTAL LIST &nbsp;
                    <i className="fas fa-print" />
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        <Switch>
          {Acl(permissions, ['E2E BPLS NEW TRANSACTION']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/new`} />}
            />
          )}
          {Acl(permissions, ['E2E BPLS RENEWAL TRANSACTION']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/renewal`} />}
            />
          )}
          <Route
            path={`${match.path}/:transaction_type`}
            component={Applications}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

ApplicationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  generateTransmittal: PropTypes.instanceOf(Function).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,

  transactionListCount: PropTypes.instanceOf(Object).isRequired,
  getTransactionCount: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
  list: _.get(api, `${c.LIST}.list`) || [],

  transactionListCount: _.get(api, `${c.GET_TRANSACTION_COUNTS}.res`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApplicationContainer);
